var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var id = function (x) { return x; };
var Left = function (value) { return ({
    _tag: 'Left',
    value: value,
}); };
var Right = function (value) { return ({
    _tag: 'Right',
    value: value,
}); };
var either = function (mapLeft, mapRight, e) { return (e._tag === 'Left' ? mapLeft(e.value) : mapRight(e.value)); };
var profunctorFn = {
    dimap: function (f, g, fn) { return function (x) { return g(fn(f(x))); }; },
    first: function (f) { return function (_a) {
        var x = _a[0], y = _a[1];
        return [f(x), y];
    }; },
    right: function (f) { return function (e) {
        return e._tag === 'Left' ? e : Right(f(e.value));
    }; },
    wander: function (f) { return function (xs) { return xs.map(f); }; },
};
var monoidFirst = {
    empty: function () { return undefined; },
    foldMap: function (f, xs) {
        for (var i = 0; i < xs.length; i++) {
            var x = f(xs[i]);
            if (x != undefined)
                return x;
        }
        return undefined;
    },
};
var monoidArray = {
    empty: function () { return []; },
    foldMap: function (f, xs) {
        var acc = [];
        xs.forEach(function (x) {
            acc = acc.concat(f(x));
        });
        return acc;
    },
};
var profunctorConst = function (monoid) { return ({
    dimap: function (f, _g, toF) { return function (x) { return toF(f(x)); }; },
    first: function (toF) { return function (_a) {
        var x = _a[0], _y = _a[1];
        return toF(x);
    }; },
    right: function (toF) { return function (e) {
        return e._tag === 'Left' ? monoid.empty() : toF(e.value);
    }; },
    wander: function (toF) { return function (xs) { return monoid.foldMap(toF, xs); }; },
}); };
export var compositionType = {
    Equivalence: {
        Equivalence: 'Equivalence',
        Iso: 'Iso',
        Lens: 'Lens',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter',
    },
    Iso: {
        Equivalence: 'Iso',
        Iso: 'Iso',
        Lens: 'Lens',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter',
    },
    Lens: {
        Equivalence: 'Lens',
        Iso: 'Lens',
        Lens: 'Lens',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter',
    },
    Prism: {
        Equivalence: 'Prism',
        Iso: 'Prism',
        Lens: 'Prism',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'AffineFold',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter',
    },
    Traversal: {
        Equivalence: 'Traversal',
        Iso: 'Traversal',
        Lens: 'Traversal',
        Prism: 'Traversal',
        Traversal: 'Traversal',
        Getter: 'Fold',
        AffineFold: 'Fold',
        Fold: 'Fold',
        Setter: 'Setter',
    },
    Getter: {
        Equivalence: 'Getter',
        Iso: 'Getter',
        Lens: 'Getter',
        Prism: 'AffineFold',
        Traversal: 'Fold',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: undefined,
    },
    AffineFold: {
        Equivalence: 'AffineFold',
        Iso: 'AffineFold',
        Lens: 'AffineFold',
        Prism: 'AffineFold',
        Traversal: 'Fold',
        Getter: 'AffineFold',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: undefined,
    },
    Fold: {
        Equivalence: 'Fold',
        Iso: 'Fold',
        Lens: 'Fold',
        Prism: 'Fold',
        Traversal: 'Fold',
        Getter: 'Fold',
        AffineFold: 'Fold',
        Fold: 'Fold',
        Setter: undefined,
    },
    Setter: {
        Equivalence: undefined,
        Iso: undefined,
        Lens: undefined,
        Prism: undefined,
        Traversal: undefined,
        Getter: undefined,
        AffineFold: undefined,
        Fold: undefined,
        Setter: undefined,
    },
};
var withTag = function (tag, optic) {
    var result = optic;
    result._tag = tag;
    return result;
};
var removable = function (optic) {
    optic._removable = true;
    return optic;
};
function compose(optic1, optic2, optic3) {
    switch (arguments.length) {
        case 2: {
            var next = function (P, optic) {
                return optic1(P, optic2(P, optic));
            };
            next._tag = compositionType[optic1._tag][optic2._tag];
            next._removable = optic2._removable || false;
            return next;
        }
        default: {
            var tag1 = compositionType[optic1._tag][optic2._tag];
            var next = function (P, optic) {
                return optic1(P, optic2(P, optic3(P, optic)));
            };
            next._tag = compositionType[tag1][optic3._tag];
            next._removable = optic3._removable || false;
            return next;
        }
    }
}
var eq = withTag('Equivalence', function (_P, optic) { return optic; });
var iso = function (there, back) {
    return withTag('Iso', function (P, optic) { return P.dimap(there, back, optic); });
};
var lens = function (view, update) {
    return withTag('Lens', function (P, optic) {
        return P.dimap(function (x) { return [view(x), x]; }, update, P.first(optic));
    });
};
var prism = function (match, build) {
    return withTag('Prism', function (P, optic) {
        return P.dimap(match, function (x) { return either(id, build, x); }, P.right(optic));
    });
};
var elems = withTag('Traversal', function (P, optic) { return P.dimap(id, id, P.wander(optic)); });
var to = function (fn) {
    return withTag('Getter', function (P, optic) { return P.dimap(fn, id, optic); });
};
/////////////////////////////////////////////////////////////////////////////
export var modify = function (optic, fn, source) {
    return optic(profunctorFn, fn)(source);
};
export var set = function (optic, value, source) {
    return optic(profunctorFn, function () { return value; })(source);
};
export var remove = function (optic, source) {
    return set(optic, removeMe, source);
};
export var get = function (optic, source) {
    return optic(profunctorConst({}), id)(source);
};
export var preview = function (optic, source) {
    return optic(profunctorConst(monoidFirst), id)(source);
};
export var collect = function (optic, source) {
    return optic(profunctorConst(monoidArray), function (x) { return [x]; })(source);
};
/////////////////////////////////////////////////////////////////////////////
var prop = function (key) {
    return lens(function (source) { return source[key]; }, function (_a) {
        var _b;
        var value = _a[0], source = _a[1];
        return (__assign(__assign({}, source), (_b = {}, _b[key] = value, _b)));
    });
};
var pick = function (keys) {
    return lens(function (source) {
        var value = {};
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            value[key] = source[key];
        }
        return value;
    }, function (_a) {
        var value = _a[0], source = _a[1];
        var result = __assign({}, source);
        for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
            var key = keys_2[_i];
            delete result[key];
        }
        return Object.assign(result, value);
    });
};
var when = function (pred) {
    return prism(function (x) { return (pred(x) ? Right(x) : Left(x)); }, id);
};
var noMatch = Symbol('__no_match__');
var mustMatch = when(function (source) { return source !== noMatch; });
var removeMe = Symbol('__remove_me__');
var at = function (i) {
    return removable(compose(lens(function (source) { return (0 <= i && i < source.length ? source[i] : noMatch); }, function (_a) {
        var value = _a[0], source = _a[1];
        if (value === noMatch) {
            return source;
        }
        if (value === removeMe) {
            if (typeof source === 'string') {
                return source.substring(0, i) + source.substring(i + 1);
            }
            else {
                return __spreadArrays(source.slice(0, i), source.slice(i + 1));
            }
        }
        if (typeof source === 'string') {
            if (i === 0) {
                return value + source.substring(1);
            }
            if (i === source.length) {
                return source.substring(0, i - 1) + value;
            }
            return source.substring(0, i) + value + source.substring(i + 1);
        }
        else {
            var result = source.slice();
            result[i] = value;
            return result;
        }
    }), mustMatch));
};
var optional = prism(function (source) { return (source === undefined ? Left(undefined) : Right(source)); }, id);
var guard = function (fn) {
    return prism(function (source) { return (fn(source) ? Right(source) : Left(source)); }, id);
};
// Like at(0), but the zero'th index must always be defined
var fst = lens(function (value) { return value[0]; }, function (_a) {
    var value = _a[0], source = _a[1];
    return [value, source[1]];
});
var find = function (predicate) {
    return removable(compose(lens(function (source) {
        var index = source.findIndex(predicate);
        if (index === -1) {
            return [noMatch, -1];
        }
        return [source[index], index];
    }, function (_a) {
        var _b = _a[0], value = _b[0], index = _b[1], source = _a[1];
        if (value === noMatch) {
            return source;
        }
        if (value === removeMe) {
            return __spreadArrays(source.slice(0, index), source.slice(index + 1));
        }
        var result = source.slice();
        result[index] = value;
        return result;
    }), fst, mustMatch));
};
var filter = function (predicate) {
    return lens(function (source) {
        var indexes = source
            .map(function (item, index) { return (predicate(item) ? index : null); })
            .filter(function (index) { return index != null; });
        return indexes.map(function (index) { return source[index]; });
    }, function (_a) {
        var values = _a[0], source = _a[1];
        var indexes = source
            .map(function (item, index) { return (predicate(item) ? index : null); })
            .filter(function (index) { return index != null; });
        var result = source.slice();
        var j = 0;
        for (var _i = 0, indexes_1 = indexes; _i < indexes_1.length; _i++) {
            var index = indexes_1[_i];
            result[index] = values[j];
            j++;
        }
        return result;
    });
};
var valueOr = function (defaultValue) {
    return lens(function (source) { return (source === undefined ? defaultValue : source); }, function (_a) {
        var value = _a[0], source = _a[1];
        return value;
    });
};
var prependTo = lens(function (source) { return undefined; }, function (_a) {
    var value = _a[0], source = _a[1];
    if (value === undefined)
        return source;
    return __spreadArrays([value], source);
});
var appendTo = lens(function (source) { return undefined; }, function (_a) {
    var value = _a[0], source = _a[1];
    if (value === undefined)
        return source;
    return __spreadArrays(source, [value]);
});
var chars = compose(iso(function (s) { return s.split(''); }, function (a) { return a.join(''); }), elems);
var words = compose(iso(function (s) { return s.split(/\b/); }, function (a) { return a.join(''); }), elems, when(function (s) { return !/\s+/.test(s); }));
/////////////////////////////////////////////////////////////////////////////
var Optic = /** @class */ (function () {
    function Optic(_ref) {
        this._ref = _ref;
    }
    Object.defineProperty(Optic.prototype, "_tag", {
        get: function () {
            return this._ref._tag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Optic.prototype, "_removable", {
        get: function () {
            return this._ref._removable;
        },
        enumerable: false,
        configurable: true
    });
    Optic.prototype.compose = function (other) {
        return new Optic(compose(this._ref, other._ref));
    };
    Optic.prototype.iso = function (there, back) {
        return new Optic(compose(this._ref, iso(there, back)));
    };
    Optic.prototype.prop = function (key) {
        return new Optic(compose(this._ref, prop(key)));
    };
    Optic.prototype.path = function (keys) {
        return new Optic(keys.reduce(function (ref, key) { return compose(ref, prop(key)); }, this._ref));
    };
    Optic.prototype.pick = function (keys) {
        return new Optic(compose(this._ref, pick(keys)));
    };
    Optic.prototype.filter = function (predicate) {
        return new Optic(compose(this._ref, filter(predicate)));
    };
    Optic.prototype.valueOr = function (defaultValue) {
        return new Optic(compose(this._ref, valueOr(defaultValue)));
    };
    Optic.prototype.optional = function () {
        return new Optic(compose(this._ref, optional));
    };
    Optic.prototype.guard_ = function () {
        var _this = this;
        return function (fn) { return _this.guard(fn); };
    };
    Optic.prototype.guard = function (fn) {
        return new Optic(compose(this._ref, guard(fn)));
    };
    Optic.prototype.at = function (i) {
        return new Optic(compose(this._ref, at(i)));
    };
    Optic.prototype.head = function () {
        return new Optic(compose(this._ref, at(0)));
    };
    Optic.prototype.index = function (i) {
        return new Optic(compose(this._ref, at(i)));
    };
    Optic.prototype.find = function (predicate) {
        return new Optic(compose(this._ref, find(predicate)));
    };
    Optic.prototype.elems = function () {
        return new Optic(compose(this._ref, elems));
    };
    Optic.prototype.to = function (fn) {
        return new Optic(compose(this._ref, to(fn)));
    };
    Optic.prototype.when = function (predicate) {
        return new Optic(compose(this._ref, when(predicate)));
    };
    Optic.prototype.chars = function () {
        return new Optic(compose(this._ref, chars));
    };
    Optic.prototype.words = function () {
        return new Optic(compose(this._ref, words));
    };
    Optic.prototype.prependTo = function () {
        return new Optic(compose(this._ref, prependTo));
    };
    Optic.prototype.appendTo = function () {
        return new Optic(compose(this._ref, appendTo));
    };
    return Optic;
}());
export { Optic };
export var optic = new Optic(eq);
